module.exports = __webpack_public_path__ + "static/bar01_3_mobile-9e4dd6ad2dd8c5afc3aebd8f3172c17a.png";